import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { BUTTON_FONT_SIZE, BUTTON_LINE_HEIGHT, BUTTON_MEDIUM_PADDING, BUTTON_MEDIUM_PADDING_FULL_WIDTH, BUTTON_SMALL_PADDING, BUTTON_SMALL_PADDING_FULL_WIDTH } from './constants';
import { buttonStyle } from './helpers';
import ButtonBaseWithContent from './components/ButtonBaseWithContent';
import { buttonTypographyStyle } from '../Typography/style/button';
import { buttonBorderRadiusStyle } from './style/border-radius';
import { lineHeight } from '../style/line-height';
import { fontSize } from '../style/font-size';
import { padding } from '../style/padding';
const StyledButton = styled(ButtonBaseWithContent)`
  ${buttonTypographyStyle}
  ${({
  size = 'medium'
}) => fontSize(BUTTON_FONT_SIZE[size] || BUTTON_FONT_SIZE.medium)}
  ${({
  size = 'medium'
}) => lineHeight(BUTTON_LINE_HEIGHT[size] || BUTTON_LINE_HEIGHT.medium)}
  
  ${buttonBorderRadiusStyle}
  ${({
  size = 'medium',
  fullWidth
}) => size === 'small' ? padding(fullWidth ? BUTTON_SMALL_PADDING_FULL_WIDTH : BUTTON_SMALL_PADDING) : padding(fullWidth ? BUTTON_MEDIUM_PADDING_FULL_WIDTH : BUTTON_MEDIUM_PADDING)}
`;
const Button = /*#__PURE__*/React.forwardRef(({
  as,
  forwardedAs,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  ...props
}, forwardedRef) => {
  const styleProps = buttonStyle[variant] || buttonStyle.primary;
  return /*#__PURE__*/React.createElement(StyledButton, _extends({}, styleProps, {
    size: size,
    fullWidth: fullWidth,
    forwardedAs: as ?? forwardedAs,
    ref: forwardedRef
  }, props));
});
export default Button;